'use client';

import Script from 'next/script';
/*
const InstallPrompt = dynamic(
  () => import('@khmyznikov/pwa-install/react-legacy'),
  {
    ssr: false,
  }
);
*/
export function Scripts({}: { isProduction: boolean }) {
  return (
    <>
      {/*
       <InstallPrompt
        name={'BB Escort'}
        description='Neu: Jetzt auch als App verfügbar'
        icon={'https://bb-escort.de/logo.svg'}
      ></InstallPrompt>
      */}

      <Script
        src='https://www.googletagmanager.com/gtag/js?id=G-VK9B18XKCK'
        strategy='afterInteractive'
      />

      <Script id='consent-init' strategy='afterInteractive'>
        {`
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}

    gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      wait_for_update: 500 // optional
    });

    gtag('js', new Date());
    gtag('config', 'G-VK9B18XKCK');
  `}
      </Script>

      <Script
        type='application/javascript'
        strategy='afterInteractive'
        data-domain='bb-escort.de'
        src='https://stats.skypleasureltd.com/js/script.js'
      ></Script>
    </>
  );
}
